import store from "@/store"

export default {
  data: function() {
    return {
      LoggedIn: false,
    };
  },

  store,
  watch: {
    "$store.state.user"() {
      this.LoggedIn = store.getters.getUser.LoggedIn;
    },
  },
};
